import { Grid, Box, Button, Typography } from '@mui/material';
import download from 'assets/images/download.jpg';
import { downloadFile } from 'services/assignment.service';
import Snackbar from 'utils/Snackbar';


const DocumentViewer = ({ currentContentData, disableFlag }: { currentContentData: any, disableFlag: any }) => {
  // Helper functions
  const getFileType = (file: any) => {
    if (!file) return '';
    return file.mimetype?.split('/').pop() || '';
  };

  const handleMouseUp = () => {
    // Add your mouse up handler logic here
  };

  const downloadFiles = async (cont_id: any, name: any) => {
    try {
      const response = await downloadFile({ fileId: cont_id });
      // const response = await downloadContentFiles({ contentId: cont_id, sectionId: contentState?.sectionId });
      const contentType = response.headers['content-type'];

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', name);
      if (contentType) {
        const ext = contentType.split('/').pop();
        link.setAttribute('download', `${name}.${ext}`);
      }
      document.body.appendChild(link);
      link.click();
      Snackbar('Course Content Downloaded Successfully.', 'success');
    } catch (error) {
      Snackbar('Unable to download the file', 'error');
    }
  };

  // Get file URL helper
  const getFileUrl = () => {
    if (currentContentData?.azureBlobUrl) {
      return `${process.env.REACT_APP_AZURE_BLOB_BASE_URL}/${currentContentData.azureBlobUrl}`;
    }
    if (currentContentData?.file?.path) {
      return process.env.REACT_APP_FILE_URL + currentContentData.file.path;
    }
    return `data:${currentContentData?.file?.mimetype};base64,${currentContentData?.file?.file}`;
  };

  // Check if file is Office document
  const isOfficeDocument = () => {
    const officeTypes = [
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'application/vnd.ms-powerpoint'
    ];
    const officeExtensions = ['doc', 'docx', 'ppt', 'pptx'];

    return (
      currentContentData?.file?.mimetype && officeTypes.includes(currentContentData.file.mimetype) ||
      (currentContentData?.azureBlobUrl && 
       officeExtensions.includes(currentContentData.azureBlobUrl.split('.').pop()?.toLowerCase()))
    );
  };

  // Render functions
  const renderOfficeViewer = () => (
    <iframe
      src={`https://view.officeapps.live.com/op/embed.aspx?src=${getFileUrl()}`}
      width="100%"
      height="450px"
      title="Embedded Office Presentation"
    />
  );

  const renderWordDownload = () => (
    <div style={{ textAlign: 'center', width: '100%', paddingTop: "20px" }}>
      <Box
        sx={{
          p: 1,
          py: 1.5,
          maxWidth: '750px',
          maxHeight: 'auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          margin: 'auto'
        }}
      >
        <img
          src={download}
          style={{ padding: '20px', width: '80%', height: '80%' }}
          alt="download"
          loading="lazy"
        />
        <Button
          color="primary"
          variant="outlined"
          onClick={() => downloadFiles(currentContentData?._id, currentContentData?.name)}
          sx={{ my: 3, ml: 2 }}
          disabled={!disableFlag}
        >
          <Typography color="primary">
            Download Copy of <span style={{ color: '#66D6F7' }}>{currentContentData?.name}</span>
          </Typography>
        </Button>
      </Box>
    </div>
  );

  const renderDefaultViewer = () => (
    <Box
      className="textDiv"
      onMouseUp={handleMouseUp}
      sx={{
        color: 'black',
        height: '70vh',
        width: '100%',
        // overflow: 'auto',
        textAlign: getFileType(currentContentData?.file) === 'pdf' ? 'center' : 'initial',
        borderRadius: 2
      }}
    >
      <object
        data={getFileUrl()}
        type={currentContentData?.file?.mimetype}
        width="100%"
        height="100%"
      />
    </Box>
  );



  // Main render
  if (!currentContentData?.file && !currentContentData?.azureBlobUrl) {
    return null;
  }

  return (
    <Grid item sx={{ width: 'inherit', px: 3, marginTop: 2, borderRadius: 2 }}>
      {isOfficeDocument() ? renderOfficeViewer() :
       currentContentData?.file?.mimetype === 'application/msword' ? renderWordDownload() :
       renderDefaultViewer()}
    </Grid>
  );
};

export default DocumentViewer;